var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteModalFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5C2 5.67 2.67 5 3.5 5H9l2 2.2h9.5c.83 0 1.5.67 1.5 1.5V9H2V6.5Z",
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 10.2c.1-.66.7-1.2 1.4-1.2h18.6c.9 0 1.55.85 1.35 1.7l-1.5 7.6c-.14.7-.76 1.2-1.47 1.2H4c-.76 0-1.4-.56-1.5-1.3L1.6 10.2Z",
    fill: "#64B5F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalFolder);
export default __webpack_public_path__ + "static/media/delete-modal-folder.f3dc40a30fe61f17fb39f9b9f3248a57.svg";
export { ForwardRef as ReactComponent };